import { IQuoteExcess, IQuote, IAllConditions } from './quote.interface';
import { IAllRiskItem, IBuilding, ICaravan, IContent, IMotorcycle, ISpecifiedItem, IVehicle } from './asset.interface';
import { ISchedule } from './schedule.interface';
import { AssetType } from '../types/asset.type';
import { InsurerIdType } from '../types/schedule.type';

export interface IInsuredAsset {
  id: number;
  policy_id: string;
  schedule: ISchedule; // SQL TODO, THIS ITEM DOESN'T EXIST ON INSURED ASSET ANY MORE??
  brolink_risk_id?: string;
  cover_start_date?: string;
  excess?: Array<IQuoteExcess>;
  excesses?: Array<IQuoteExcess>;
  premium: number;
  sum_insured: number;
  sum_insured_type?: string;
  sasria?: number;
  extension: IExtention;
  optional_covers?: Array<IOptionalCover>;
  number_claims_last_12_months: number;
  number_claims_last_13_to_24_months: number;
  number_claims_last_25_to_36_months: number;
  optional_credit_shortfall: boolean;
  preferred_excess: string;
  insurance_history: boolean;
  claim_free_group: string;
  commission: number;
  ctrl_id: string;
  insurer_specific_section: string;
  quotes_id: number;
  specified_items_id: number;
  schedule_id: number;
  user_id: number;
  asset_details?: IVehicle | IBuilding | IContent | IAllRiskItem | ICaravan | IMotorcycle | ISpecifiedItem;
  contents_id?: number;
  buildings_id?: number;
  vehicles_id?: number;
  motorcycles_id?: number;
  caravans_id?: number;
  all_risks_id?: number;
  quote_detail?: Array<IQuote>
  type?: AssetType;
  insurer_id?: InsurerIdType;
  selected?: boolean;
  conditions?: Array<IAllConditions>
}

export interface IOptionalCover {
  created_time: string;
  description: string;
  id: number;
  modified_time: string;
  premium: number;
  quote_vehicles_id: number;
  sum_insured: number;
}
export interface IScheduleInsuredAssets {
  contents: IInsuredContent[];
  buildings: IInsuredBuilding[];
  caravans: IInsuredCaravan[];
  motorcycles: IInsuredMotorcycle[];
  vehicles: IInsuredVehicle[];
  vaps: IInsuredVaps[];
  all_risks: IInsuredAllRisk[];
  specified_items: IInsuredSpecifiedItem[];
}

export interface IInsuredBuilding extends IInsuredAsset {
  asset_detail: IBuilding;
  optional_and_value_added_cover: IOptionalAndValueAddedCoverBuildings;
  details?: IInsuredAddressDetails;
  selected: boolean;

  extension_accidental_damage_to_machinery: boolean;
  geyser: boolean;
  optional_subsidence: boolean;
  home_assist: boolean;
  extension_power_surge: boolean;
  optional_baboon_cover: boolean;
  address?:IInsuredAddressDetails;
}

export interface IInsuredCaravan extends IInsuredAsset {
  asset_detail: ICaravan;
  optional_and_value_added_cover: IOptionalAndValueAddedCoverCaravan;
  details?: IInsuredVehicleDetails;
  selected: boolean;
  regular_driver_license_expiry_date?: string;
  make: string;
  model: string;
  roadside_assistance: boolean;
  optional_excess_waiver: boolean;
  extension_specified_accessories: boolean;
}

export interface IInsuredContent extends IInsuredAsset {
  asset_detail: IContent;
  optional_and_value_added_cover: IOptionalAndValueAddedCoverContent;
  details?: IInsuredAddressDetails;
  selected: boolean;
  extension_power_surge: boolean;
  home_assist: boolean;
  optional_subsidence: boolean;
  optional_baboon_cover: boolean;
  extension_accidental_damage: boolean;
  extension_mech_elec_electronic_damage: boolean;
  address?:IInsuredAddressDetails;
}

export interface IInsuredMotorcycle extends IInsuredAsset {
  asset_detail: IMotorcycle;
  optional_and_value_added_cover: IOptionalAndValueAddedCoverMotorcycle;
  details?: IInsuredVehicleDetails;
  selected: boolean;
  regular_driver_license_expiry_date?: string;
  make: string;
  model: string;
  car_hire_premium: boolean;
  extension_car_hire: boolean;
  extension_premium: number;
  miway_object_no: string;
  miway_policy_line_no: number;
  optional4x4: boolean;
  optional_excess_waiver: boolean;
  roadside_assistance: boolean;
  vehicles_id: number;
}

export interface IExtention {
  message: string;
  premium: number;
}

export interface IInsuredVehicle extends IInsuredAsset {
  asset_detail: IVehicle;
  extension_specified_accessories: boolean;
  licence_year: boolean;
  regular_driver_id: string;
  regular_driver_license_date: string;
  usual_driver_age: boolean;
  special_conditions: boolean;
  details?: IInsuredVehicleDetails;
  selected: boolean;
  optional_and_value_added_cover: IOptionalAndValueAddedCoverVehicle;
  regular_driver_license_expiry_date?: string;
  make: string;
  model: string;
  car_hire_premium: boolean;
  extension_car_hire: boolean;
  extension_premium: number;
  miway_object_no: string;
  miway_policy_line_no: number;
  optional4x4: boolean;
  optional_excess_waiver: boolean;
  roadside_assistance: boolean;
  vehicles_id: number;
}

export interface IInsuredVaps extends IInsuredAsset {
  asset_class: string;
  cover_end_date: string;
  details?: IInsuredVapsDetails;
  level_of_cover?: ILevelOfCover;
  product_id: string;
  product_type: string;
  specified_item?: ISpecifiedItem;
}

export interface IOptionalAndValueAddedCoverBuildings {
  extension_accidental_damage_to_machinery: boolean;
  extension_power_surge: boolean;
  geyser: boolean;
  home_assist: boolean;
  optional_baboon_cover: boolean;
  optional_subsidence: boolean;
}

export interface IOptionalAndValueAddedCoverMotorcycle {
  extension_car_hire: boolean;
  optional_excess_waiver: boolean;
  roadside_assistance: boolean;
}
export interface IOptionalAndValueAddedCoverCaravan {
  extension_specified_accessories: boolean;
  optional_excess_waiver: boolean;
  roadside_assistance: boolean;
}
export interface IOptionalAndValueAddedCoverContent {
  extension_accidental_damage: boolean;
  extension_mech_elec_electronic_damage: boolean;
  extension_power_surge: boolean;
  home_assist: boolean;
  optional_baboon_cover: boolean;
  optional_subsidence: boolean;
}

export interface IOptionalAndValueAddedCoverVehicle {
  extension_car_hire: boolean;
  extension_specified_accessories: boolean;
  optional_4x4: boolean;
  optional_credit_shortfall: boolean;
  optional_excess_waiver: boolean;
  roadside_assistance: boolean;
}

interface IInsuredVehicleDetails {
  make: string;
  model: string;
  registration_nr: string;
}

export interface ILevelOfCover {
  description: string;
  value: string;
}

interface IInsuredAddressDetails {
  postalCodeId: string;
  risk_address_line1: string;
  risk_address_line2: string;
}

interface IInsuredVapsDetails {
  postalCodeId: string;
  risk_address_line1: string;
  risk_address_line2: string;
  make: string;
  model: string;
  registration_nr: string;
}

// TODO: Check if this should not extend IInsuredAsset
export interface IInsuredSpecifiedItem extends IInsuredAsset {
  schedule: ISchedule;
  sum_insured: number;
  specified_item?: ISpecifiedItem;
  specified_item_id?: string;
  insured_amount: number;
  effective_date: Date;
  premium: number;
  selected: boolean;
  // excess: ISpecifiedItemExcess;
  special_conditions: Array<string>;
}

export interface IInsuredAllRisk extends IInsuredAsset {
  details?: IInsuredAllRiskDetails;
  asset_detail?: IInsuredAllRiskDetails;
  selected: boolean;
  description?: string;
}
export interface IInsuredAllRiskDetails {
  description?: string;
}
export interface IPersonalGoods {
  insured_amount: number;
  effective_date: Date;
  premium: number;
  excess: number;
}

export interface ISpecifiedItemExcess {
  basic: number;
  basic_percentage: number;
}
